/* eslint-disable no-shadow */
import { FormFields, FormValidationSchema } from '../../common/interfaces';
import { ProxyServer } from './entities';

export enum ProxyServerFormInputs {
  Name = 'name',
  Password = 'password',
  Ips = 'ips',
  Ip = 'ip',
  HostingId = 'hostingId',
  HostingAccountId = 'hostingAccountId'
}

export type ProxyServerFormFields = FormFields<typeof ProxyServerFormInputs>;

export type ProxyServerFormValidationSchema = FormValidationSchema<ProxyServerFormFields>;

export type ProxyServerAutocomplete = Pick<ProxyServer, 'id' | 'name'>[];


export interface SupportedLinuxOS {
  id: string;
  version: string;
  codename?: string;
}
